import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { apiList, getCancelData } from '../api/callAPI';
import useUser from '../hook/useUser';
import useCancel from '../hook/useCancel';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';

import { presetExcelSheets } from '../utils/GoogleFieldsDefined';

import _ from 'lodash'
import axios from 'axios';

const useLineFieldsData = () => {
  const history = useHistory();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const [isLoading, setIsLoading] = useState(true);
  const [lineDefinition, setLineDefinition] = useState([]);
  const { cancelData, setCancelData } = useCancel();
  const [isLoadingData, setIsLoadingData] = useState(false);

  const fetchColumnDefinition = () => {

    let fieldsDefined;

    fieldsDefined = apiList.lineDefinition({})

      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

        if (res.status === 200) {
          // console.log('googleDefinition-res', res);
          setLineDefinition(res.data);
          setIsLoading(false);
        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  useEffect(() => {
    fetchColumnDefinition();
  }, [])

  //自定義指標欄位
  const initializeCustomFields = [
    {
      category: 'custom',
      name: '自定義指標',
      child: []
    }
  ]

  //排序欄位
  const fieldsSort = lineDefinition.sort((a, b) => {
    return a.categoryIndex - b.categoryIndex;
  });

  //非固定欄位
  const filterFieldsData = fieldsSort.filter((el) => {
    return el.categoryName !== "固定欄位";
  })

  //欄位(回傳格式)
  const generalData = filterFieldsData.map((edition, index) => {
    return {
      name: edition.name,
      expression: edition.lineapi,
      format: edition.format,
      type: edition.type,
      sheet: edition.excel
    }
  })

  //欄位(顯示分類)
  const fixedFields = Array.from(
    new Set(filterFieldsData.map((s) => s.categoryName))
  ).map((lab, index) => {
    return {
      category: `${lab}_${index}`,
      name: lab,
      child: filterFieldsData.filter((s) => s.categoryName === lab)
      .map((edition) => {
        return {
          name: edition.name,
          expression: edition.lineapi,
          format: edition.format,
          type: edition.type,
          sheet: edition.excel
        }
      })
    }
  })

  const allFixedFields = initializeCustomFields.concat(fixedFields);

  //把資料回傳出去
  return [
    lineDefinition,
    generalData,
    allFixedFields
  ];

};

export default useLineFieldsData;